import React, { useState, useEffect } from 'react'
import { Button, TextField, Typography, Stack, Grid, CircularProgress, FormLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TestData = ({ type, testResult, getTestData, sendTestRequest, input, clear, isLoading, disabled, errorMessage }) => {
    const { t } = useTranslation();
    const [testInput, setTestInput] = useState(input);

    const endAdornment = (
        <Grid container alignItems="center" justify="center">
            <CircularProgress size={20} />
        </Grid>
    );

    useEffect(() => {
        if (clear) {
            setTestInput('');
        }
    }, [clear])

    return (
        <>
            <Stack spacing={"15px"} xs={{mt:'15px'}}>
                <FormLabel>{t(type)}</FormLabel>
                <TextField
                    disabled={disabled}
                    label={t('LBL_TEST_DATA')}
                    multiline
                    minRows={4}
                    maxRows={7}
                    variant="outlined"
                    name="TEST_DATA"
                    value={testInput || ''}
                    onChange={(e) => {
                        if (encodeURIComponent(e.target.value) === '%0A') {
                            setTestInput('\n');
                            getTestData('\\n');
                        } else if (/^%0A*$/.test(encodeURIComponent(e.target.value))) {
                            const testData = encodeURIComponent(e.target.value).replace(/%0A/g, '\n');
                            setTestInput(testData);
                            getTestData(testData);
                        } else {
                            setTestInput(e.target.value);
                            getTestData(e.target.value);
                        }
                    }}
                    // inputProps={{
                    //     style: {
                    //         height: "100%"
                    //     }
                    // }}
                    InputProps={{
                        style: {
                            overflowY: 'auto',
                            // resize: 'vertical',
                            // minHeight: '75px',
                            // maxHeight: '300px',
                        }
                    }}
                />
                <TextField
                    label={isLoading ? '' : t('LBL_TEST_RESULT')}
                    multiline
                    minRows={4}
                    maxRows={7}
                    variant="outlined"
                    value={isLoading ? '' : testResult}
                    readOnly={true}
                    disabled={true}
                    InputLabelProps={{
                        style: {
                            WebkitTextFillColor: "#00000099" //  counters the color change from disabled={true}
                        }
                    }}
                    inputProps={{
                        style: {
                            // height: "100%",
                            WebkitTextFillColor: "#000000DE" //  counters the color change from disabled={true}
                        }
                    }}
                    InputProps={{
                        endAdornment: isLoading ? endAdornment : null,
                        style: {
                            overflowY: 'auto',
                            // resize: 'vertical',
                            // minHeight: '75px',
                            // maxHeight: '300px',
                        }
                    }}
                />
                {/* Error Message Display */}
                {errorMessage && (
                    <Typography 
                        variant="body2" 
                        color="error" 
                        sx={{ 
                            mt: 1, 
                            p: 1, 
                            backgroundColor: 'rgba(211, 47, 47, 0.1)', 
                            borderRadius: 1,
                            border: '1px solid rgba(211, 47, 47, 0.3)'
                        }}
                    >
                        {errorMessage}
                    </Typography>
                )}
                <Button
                    size="small"
                    variant="outlined"
                    fullWidth
                    onClick={() => sendTestRequest(true)}
                    disabled={isLoading || disabled}
                >
                    {t('BTN_TEST_IT')}
                </Button>
            </Stack>
        </>
    )
}

export default TestData